import * as React from 'react';
import App from './App';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as colors from 'material-ui/styles/colors';

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
const muiTheme = getMuiTheme({
    palette: {
        //textColor: colors.lightBlue900,
        //textColor: colors.green900,
        textColor: colors.grey800,
    },
    appBar: {
        color: colors.lightBlue900,
        textColor: colors.grey50
    },
    toolbar: {
        backgroundColor: colors.grey200,
        hoverColor: colors.green900
    },
    flatButton: {
        //color: colors.green900,
    },
    bottomPanel: {
        background: colors.lightBlue100,
    }
});

// MuiThemeProvider takes the theme as a property and passed it down the hierarchy.
const Root = () => (
    <MuiThemeProvider muiTheme={muiTheme}>
        <App />
    </MuiThemeProvider>
);

export default Root;


// WEBPACK FOOTER //
// ./src/app/Root.js